import classNames from "classnames";
import React from "react";

/**
 * Circular or square avatar skeleton.
 *
 * @param {number}  size  — pixel size (default: uses --skeleton-avatar-size token)
 * @param {string}  shape — 'circle' | 'square' (default: 'circle')
 * @param {string}  className
 */
const SkeletonAvatar = ({ size, shape = "circle", className }) => {
  return (
    <div
      className={classNames(
        "skeleton",
        { "skeleton--circle": shape === "circle" },
        className,
      )}
      style={{
        width: size ?? "var(--skeleton-avatar-size)",
        height: size ?? "var(--skeleton-avatar-size)",
        flexShrink: 0,
      }}
      aria-hidden="true"
    />
  );
};

export default SkeletonAvatar;
